
/* 
------------------------------------------------------------------------------------------------------------------------
CUSTOM CODE - STEVE: 

Multiple JS snippets for different functionalities.
------------------------------------------------------------------------------------------------------------------------
*/



/* 

This script is made to re-render an existing bug with the yotpo-carrousel widget. 
The widget generates <h3> headlines which harm SEO.

Currently, the script is waiting for the page to load and then replaces the <h3>-element
with a <div> tag. It doesn't always replace all elements since yotpo utilizes 
copy-slides with tend to re-sync with yotpo's servers dynamically. 

*/

    // add event listener
    window.addEventListener('load', function() {
    
    // declare variables
    var reviewsRaw = document.getElementsByClassName("review-title");
    var reviewsNew;
    
    // replace <h3> headlines with <div> element
    Array.from(reviewsRaw).forEach(element => {
        reviewsNew = document.createElement("div");
        reviewsNew.classList.add("review-title");
        reviewsNew.classList.add("h3");
        reviewsNew.innerHTML = element.innerHTML;
        element.replaceWith(reviewsNew);
    }); 

})


/* 

This script is made to hide the intercom widget on mobile. 

Whenever the menu is toggled (opened), this scripts hides the widget. 

*/

const menuToggleButton = document.getElementsByClassName("header__icon-list")[0].firstElementChild;

const observer = new MutationObserver((mutations) => {
    const intercomWidget = document.getElementsByClassName("intercom-lightweight-app")[0];
    mutations.forEach((mutation) => {
        if (mutation.attributeName === "aria-expanded") {
            const expanded = menuToggleButton.getAttribute('aria-expanded');
            if (expanded === "true") {
                intercomWidget.style.display = "none";
            } else {
                intercomWidget.style.display = "";
            }
        }
    });
});

observer.observe(menuToggleButton, { attributes: true });